import { render, staticRenderFns } from "./googleSsoBtn.vue?vue&type=template&id=e1c46e90&scoped=true"
import script from "./googleSsoBtn.vue?vue&type=script&lang=js"
export * from "./googleSsoBtn.vue?vue&type=script&lang=js"
import style0 from "./googleSsoBtn.vue?vue&type=style&index=0&id=e1c46e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c46e90",
  null
  
)

export default component.exports